import React, { Fragment, useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './FeedbackData';
import { Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import ViewIcon from '../../assets/images/svg/EyeView.svg';
import ShareIcon from '../../assets/images/svg/publishLearning.svg';
// import DeleteIcon from '../../assets/images/svg/delete-icon.svg'; 

// Import the icons for search, calendar, and filter
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';
// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// You can use the same styling as in your LearningTable or adjust as needed


const FeedbackTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [feedbackToDelete, setFeedbackToDelete] = useState(null);

    // New state variables for search, calendar, and filter
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'Last 7 days', value: '7days' },
        { label: 'Last 30 days', value: '30days' },
        { label: 'Custom', value: 'custom' }
    ];

    // Click outside handlers
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            // Replace with your actual API endpoint for getting feedback
            const response = await axios.get(`${ServerPath}/feedback/all`);

            if (response.data.success) {
                const transformedData = response.data.data.map(item => ({
                    feedback_id: item.feedback_id,
                    user_id: item.user_id,
                    user_name: item.user_name,
                    description: item.description,
                    created_on: item.created_on,
                    created_on_formatted: formatDate(item.created_on),
                    original_created_on: new Date(item.created_on), // Store original date for filtering
                    created_by: item.created_by,
                    action: (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn btn-link p-0"
                                title="View Details"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewFeedback({
                                        ...item,
                                        created_on_formatted: formatDate(item.created_on)
                                    });
                                }}
                            >
                                {/* Replace with your actual view icon */}
                                <img src={ViewIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <button
                                className="btn btn-link p-0"
                                title="Delete"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteClick(item.feedback_id);
                                }}
                            >

                            </button>
                        </div>
                    ),
                    raw_data: item // Store the original data
                }));

                setData(transformedData);
                setOriginalData(transformedData); // Store original data for filtering
                setTotalRows(transformedData.length);
            }
        } catch (error) {
            console.error('Error fetching feedback:', error);
            toast.error('Failed to fetch feedback data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, perPage]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        
        // Handle predefined date ranges
        let dateRangeValue = null;
        if (value === '7days') {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 7);
            
            const newRange = {
                startDate,
                endDate,
                key: 'selection'
            };
            setDateRange([newRange]);
            dateRangeValue = newRange;
        } else if (value === '30days') {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 30);
            
            const newRange = {
                startDate,
                endDate,
                key: 'selection'
            };
            setDateRange([newRange]);
            dateRangeValue = newRange;
        } else if (value === 'custom') {
            setShowCalendar(true);
            // Use existing date range if available
            dateRangeValue = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        } else {
            // Clear date range for 'all'
            const clearedRange = {
                startDate: null,
                endDate: null,
                key: 'selection'
            };
            setDateRange([clearedRange]);
            dateRangeValue = null;
        }
        
        applyFiltersAndSearch(searchValue, value, dateRangeValue);
        if (value !== 'custom') {
            setShowDropdown(false);
        }
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, 'custom', item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        setSelectedFilter('all');
        applyFiltersAndSearch(searchValue, 'all', null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.feedback_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.user_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.user_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.description || '').toLowerCase().includes(searchTerm) ||
                    String(item.created_by || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.original_created_on) return false;
                
                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                return item.original_created_on >= startDate && item.original_created_on <= endDate;
            });
        }

        setData(filteredData);
    };

    const handleViewFeedback = (feedback) => {
        setSelectedFeedback(feedback);
        setShowViewModal(true);
    };

    const handleDeleteClick = (feedbackId) => {
        setFeedbackToDelete(feedbackId);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            const response = await axios.post(`${ServerPath}/feedback/delete`, {
                feedback_id: feedbackToDelete
            });

            if (response.data.success) {
                toast.success('Feedback deleted successfully');
                fetchData(); // Refresh the data
            } else {
                toast.error(response.data.message || 'Failed to delete feedback');
            }
        } catch (error) {
            console.error('Error deleting feedback:', error);
            toast.error('Failed to delete feedback');
        } finally {
            setShowDeleteModal(false);
            setFeedbackToDelete(null);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    return (
        <Fragment>
            {/* <style>{tableStyles}</style> */}
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Feedback</h4>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                        .date-range {
                                            font-size: 12px !important;
                                        }
                                        .date-range .rdrMonth {
                                            width: 240px !important;
                                            padding: 0 !important;
                                        }
                                        .date-range .rdrCalendarWrapper {
                                            font-size: 12px !important;
                                            width: 240px !important;
                                            border-radius: 8px !important;
                                            overflow: hidden !important;
                                            background: white !important;
                                        }
                                        .date-range .rdrDateDisplayWrapper {
                                            display: none !important;
                                        }
                                        .rdrMonthAndYearWrapper {
                                            padding-top: 5px !important;
                                            height: 40px !important;
                                        }
                                        .rdrMonth {
                                            padding: 0 !important;
                                        }
                                    `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <style>
                                        {`
                                            .form-check-label {
                                                font-weight: 400 !important;
                                            }
                                            .form-check-input[type=checkbox] {
                                                border-radius: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    progressPending={loading}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* View Feedback Modal */}
            <ViewFeedbackModal
                show={showViewModal}
                onHide={() => setShowViewModal(false)}
                feedback={selectedFeedback}
            />

            {/* Delete Confirmation Modal */}
            <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirm}
                title="Delete Feedback"
                message="Are you sure you want to delete this feedback? This action cannot be undone."
            />
        </Fragment>
    );
};

// View Feedback Modal Component
const ViewFeedbackModal = ({ show, onHide, feedback }) => {
    if (!feedback) return null;

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Feedback Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-3">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Feedback ID:</strong></p>
                            <p className="text-muted">{feedback.feedback_id}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Date:</strong></p>
                            <p className="text-muted">{feedback.created_on_formatted}</p>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <p className="mb-1"><strong>User ID:</strong></p>
                            <p className="text-muted">{feedback.user_id}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-1"><strong>User Name:</strong></p>
                            <p className="text-muted">{feedback.user_name}</p>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-12">
                            <p className="mb-1"><strong>Feedback:</strong></p>
                            <div className="p-3 bg-light rounded">
                                <p className="mb-0 text-muted">{feedback.description}</p>
                            </div>
                        </div>
                    </div>

                    {feedback.created_by && (
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-1"><strong>Created By:</strong></p>
                                <p className="text-muted">{feedback.created_by}</p>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

// Confirmation Modal Component
const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-danger bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-triangle-fill fs-4 text-danger"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="danger" className="px-4" onClick={onConfirm}>Delete</Button>
                <Button variant="light" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default FeedbackTable;